var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "User Management" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex justify-between items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "search name" },
                                on: { change: _vm.searchUser },
                                model: {
                                  value: _vm.filter.q,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "q", $$v)
                                  },
                                  expression: "filter.q"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "Select Type"
                                  },
                                  model: {
                                    value: _vm.filter.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "type", $$v)
                                    },
                                    expression: "filter.type"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    key: 0,
                                    attrs: { value: 0, label: "Free" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: 1,
                                    attrs: { value: 1, label: "Subscriber" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "Select Country"
                                  },
                                  model: {
                                    value: _vm.filter.country_code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "country_code", $$v)
                                    },
                                    expression: "filter.country_code"
                                  }
                                },
                                _vm._l(_vm.dataCountries, function(c) {
                                  return _c("el-option", {
                                    key: c.id,
                                    attrs: { value: c.id, label: c.label }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: { label: "Apply" },
                            on: { clicked: _vm.searchUser }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            { staticClass: "p-2" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "sync"] },
                                on: { click: _vm.reset }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "download-excel",
                        {
                          staticClass: "md:w-50",
                          attrs: {
                            data: _vm.data,
                            fields: _vm.excel_fields,
                            meta: _vm.excel_meta,
                            worksheet: "My Worksheet",
                            name: "users.xls"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center px-4 py-3 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                              class: "bg-indigo-500 text-gray-100"
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "m-auto text-xs font-medium" },
                                [
                                  _vm._v(
                                    "\n                Download Excel\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableUser",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [20, 50, 100, 300, 500]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop.field,
                        attrs: {
                          prop: title.prop.field,
                          label: title.label,
                          sortable: "custom",
                          width: title.prop.width
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm.isSuperAdmin || _vm.isAdmin || _vm.isOps
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            width: "200px",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        scope.row.email_verified_at === null
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Resend Email",
                                                  position: "is-right"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.resendEmail(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "envelope-square"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "Detail",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.detailUser(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: { icon: ["fa", "eye"] }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.statusCode !== 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Block",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-red-700 hover:bg-red-800 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.blockUser(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "ban"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.statusCode === 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Unblock",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.unBlockUser(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "circle-notch"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isOps
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Delete",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteUser(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2247391119
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          attrs: {
            isShowingModal: _vm.isShowingModal,
            isLoading: _vm.isLoading,
            title: "Detail User",
            size: "large"
          },
          on: {
            toggleModal: function($event) {
              return _vm.toggleModal()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "w-full p-2 modal-content" }, [
              _c(
                "ul",
                {
                  staticClass:
                    "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            " text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                          class: {
                            "text-blue-500 bg-white":
                              _vm.userDetailOpenTab !== 1,
                            "text-white bg-blue-500":
                              _vm.userDetailOpenTab === 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleTabsUserDetail(1)
                            }
                          }
                        },
                        [_vm._v("\n              Detail\n            ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                          class: {
                            "text-blue-500 bg-white":
                              _vm.userDetailOpenTab !== 2,
                            "text-white bg-blue-500":
                              _vm.userDetailOpenTab === 2
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleTabsUserDetail(2)
                            }
                          }
                        },
                        [_vm._v("\n              Song Purchased\n            ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                          class: {
                            "text-blue-500 bg-white":
                              _vm.userDetailOpenTab !== 3,
                            "text-white bg-blue-500":
                              _vm.userDetailOpenTab === 3
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleTabsUserDetail(3)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              Album Purchased\n            "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
                },
                [
                  _c("div", { staticClass: "px-4 py-5 flex-auto" }, [
                    _c("div", { staticClass: "tab-content tab-space" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mx-400 ",
                          class: {
                            hidden: _vm.userDetailOpenTab !== 1,
                            block: _vm.userDetailOpenTab === 1
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tab-user" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row pb-4 px-20"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 flex flex-col md:flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-full flex-1 mx-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.user.avatar,
                                                  width: "100"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row border-b border-gray-200"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800"
                                    },
                                    [_vm._v("Full Name")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 flex flex-col md:flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-full flex-1 mx-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(_vm.user.name))
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row border-b border-gray-200"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800"
                                    },
                                    [_vm._v("Email")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 flex flex-col md:flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-full flex-1 mx-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(_vm.user.email))
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row border-b border-gray-200"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800"
                                    },
                                    [_vm._v("Country")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "w-full flex-1 mx-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-1 flex flex-col md:flex-row"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(_vm.user.country_name)
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row border-b border-gray-200"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800"
                                    },
                                    [_vm._v("Status")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 flex flex-col md:flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-full flex-1 mx-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(_vm.user.status))
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col md:flex-row border-b border-gray-200"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-32 text-left font-bold h-6 mx-2 mt-3 text-gray-800"
                                    },
                                    [_vm._v("Type")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 flex flex-col md:flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "w-full flex-1 mx-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "my-2 p-1 flex" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.user.type == 0
                                                      ? "Free"
                                                      : "Subscriber"
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "data-tables",
                                {
                                  attrs: {
                                    layout: "table",
                                    data: _vm.user.devices,
                                    total: _vm.user.devices.length,
                                    "pagination-props": { pageSizes: [100] }
                                  }
                                },
                                _vm._l(_vm.titlesDevice, function(title) {
                                  return _c("el-table-column", {
                                    key: title.prop,
                                    attrs: {
                                      prop: title.prop,
                                      label: title.label,
                                      sortable: "custom"
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "mx-400 ",
                          class: {
                            hidden: _vm.userDetailOpenTab !== 2,
                            block: _vm.userDetailOpenTab === 2
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pb-6 flex justify-between items-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mr-2" },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "search song" },
                                        on: { change: _vm.searchSong },
                                        model: {
                                          value: _vm.qwordSong,
                                          callback: function($$v) {
                                            _vm.qwordSong = $$v
                                          },
                                          expression: "qwordSong"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("Button", {
                                    attrs: { label: "Apply" },
                                    on: { clicked: _vm.searchSong }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    { staticClass: "p-2" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "sync"] },
                                        on: { click: _vm.resetSong }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "data-tables-server",
                            {
                              ref: "tableSong",
                              attrs: {
                                data: _vm.dataSong,
                                total: _vm.totalSong,
                                "pagination-props": {
                                  background: true,
                                  pageSizes: [_vm.displayingItem]
                                }
                              },
                              on: { "query-change": _vm.onChangeTableSong }
                            },
                            _vm._l(_vm.titlesSong, function(title) {
                              return _c("el-table-column", {
                                key: title.prop,
                                attrs: {
                                  prop: title.prop,
                                  label: title.label,
                                  sortable: "custom"
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "mx-400 ",
                          class: {
                            hidden: _vm.userDetailOpenTab !== 3,
                            block: _vm.userDetailOpenTab === 3
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pb-6 flex justify-between items-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mr-2" },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "search album" },
                                        on: { change: _vm.searchAlbum },
                                        model: {
                                          value: _vm.qwordSong,
                                          callback: function($$v) {
                                            _vm.qwordSong = $$v
                                          },
                                          expression: "qwordSong"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("Button", {
                                    attrs: { label: "Apply" },
                                    on: { clicked: _vm.searchSong }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    { staticClass: "p-2" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "sync"] },
                                        on: { click: _vm.resetAlbum }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "data-tables-server",
                            {
                              ref: "tableAlbum",
                              attrs: {
                                data: _vm.dataAlbum,
                                total: _vm.totalAlbum,
                                "pagination-props": {
                                  background: true,
                                  pageSizes: [_vm.displayingItem]
                                }
                              },
                              on: { "query-change": _vm.onChangeTableAlbum }
                            },
                            _vm._l(_vm.titlesAlbum, function(title) {
                              return _c("el-table-column", {
                                key: title.prop,
                                attrs: {
                                  prop: title.prop,
                                  label: title.label,
                                  sortable: "custom"
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68be103e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68be103e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Users.vue
// module id = null
// module chunks = 